<template>
  <div class="p-3 pl-5">
    <div class="vertical-line" v-for="(item, index) in logs" :key="index">
      <div class="circle">
        <div class="dot"></div>
      </div>
      <div class="pl-3 content-log">
        <strong>{{ item.name }}</strong>
        <div class="d-flex align-items-center mb-1 text-blue-400">
          <i class="fa fa-calendar mr-2"></i>
          <p class="text-sm mb-0">{{ formateDate(item.date_log) }}</p>
        </div>
        <small>{{ item.log_description }}</small>
      </div>
    </div>
  </div>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import { srActions } from '@/src/Utils/helper'

export default {
  props: {
    selectedItem: {
      type: Object,
      default: () => {},
    },
    defaultParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      logs: [],
    }
  },
  methods: {
    ...srActions,
    async getLogs() {
      const query = {
        params: {...this.defaultParams},
        id: this.selectedItem.id,
      }
      let res = await this.fetchLogs(query)
      this.logs = null
      if (res?.status === 'error') {
        this.logs = null
      } else {
        this.logs = res.data
      }
    },
    formateDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm')
    },
    watch: {
      selectedItem(newValue) {
        this.getLogs()
      },
    },
  },

  mounted() {
    this.getLogs()
  },
}
</script>
<style scoped>
.vertical-line {
  border-left: 2.4px solid #e5e7eb;
  min-height: 100px;
  position: relative;
}
.circle {
  width: max-content;
  border: 1.5px solid #1f48aa;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  padding: 4px;
  position: absolute;
  left: -10px;
  top: -6px;
}
.dot {
  width: 8px;
  height: 8px;
  background: #1f48aa;
  border-radius: 50%;
}
.text-blue-400 {
  color: #334697;
}
</style>
